/*! hash:06b0d4e8a9e4ea1bc02d, chunkhash:60068710c771890efa4d, name:openPlatform/index, filebase:index.60068710c.js, query:, file:static/js/openPlatform/index.60068710c.js */
webpackJsonp([6],{

/***/ 13:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

__webpack_require__(1);

__webpack_require__(13);

__webpack_require__(2);

$(function () {
  var ele1 = $('.num-wrapper').find('.num1');
  countUp(ele1, 25000, 0, 1000, 0);
  var ele2 = $('.num-wrapper').find('.num2');
  countUp(ele2, 3000, 0, 1000, 0);
  var ele3 = $('.num-wrapper').find('.num3');
  countUp(ele3, 70000, 0, 1000, 0);
});
function countUp(elem, endVal, startVal, duration, decimal) {
  var startTime = 0;
  var dec = Math.pow(10, decimal);
  var progress, value;

  function startCount(timestamp) {
    if (!startTime) startTime = timestamp;
    progress = timestamp - startTime;
    value = startVal + (endVal - startVal) * (progress / duration);
    value = value > endVal ? endVal : value;
    value = Math.floor(value * dec) / dec;
    elem.html(value.toFixed(decimal));
    progress < duration && requestAnimationFrame(startCount);
  }

  requestAnimationFrame(startCount);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ })

},[29]);


// WEBPACK FOOTER //
// static/js/openPlatform/index.60068710c.js